<template>
  <div>
    <Visual />

    <div class="section" v-if="$store.state.iframeMode === false">
      <div class="container">
        <p>Tektalan® steht für effiziente und zuverlässige Dämmlösungen, ökologisch und nah an der Natur – denn die natürlichen und nicht-brennbaren Holzwolle-Mehrschichtplatten sorgen für eine optimale und nachhaltige Wärmedämmung. Die neuen Produktgruppen bieten exklusive Vorteile, die für jede Aufgabe die optimale Dämmlösung bereithalten.</p>
      </div>
    </div>

      <!--
      <Modal v-on:close="() => showModal = false" v-if="showModal">
        <h2>Ich bin eine zweizeilige Headline</h2>
        <p>Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean.</p>
        <p>Small river named Duden flows by their place and supplies it with the necessary regelialia. It is a paradisematic country, in which roasted parts of sentences fly into your mouth.</p>
      </Modal>

      <button @click="() => showModal = true">DEBUG</button>
      -->
    <section class="section" v-if="$store.state.iframeMode === false">
      <div class="container container--small">
        <h2 class="size--l">Finden Sie jetzt die perfekte Lösung für Ihre Bedürfnisse!</h2>
        <Button variant="primary" url="/finder" text="Zum Produktfinder" />
        <Button variant="secondary" url="/products" text="Zur Produktübersicht" />
      </div>
    </section>

    <section class="section" v-if="$store.state.iframeMode === false">
      <div class="container">
        <h2 class="size--xl">Die neue Tektalan® Produktwelt auf einen Blick</h2>
        <p>Erleben Sie die vielfältigen Einsatzmöglichkeiten der Tektalan® A2-Produkte!</p>

        <carousel class="slider" :perPage="1" :perPageCustom="[[768, 2]]">
          <slide class="slider__item" v-for="(slide, index) in slider" v-bind:key="index">
            <router-link class="teaser" :to="'/products/' + slide.slug">
              <div class="teaser__image" :style="`background-image: url(${require(`@/assets/img/backgrounds/category/${slide.image}.jpg`)});`"></div>

              <div class="teaser__text">
                <h3 class="size--l">{{ slide.headline }}</h3>
                <p>{{ slide.text }}</p>
              </div>
            </router-link>
          </slide>
        </carousel>
      </div>
    </section>
  </div>
</template>

<script>
import Visual from '@/components/Visual.vue';
import Button from '@/components/Button.vue';
import groups from '@/assets/json/groups.json';

export default {
  components: {
    Visual,
    Button,
  },
  mounted() {
    this.$store.dispatch('restartFinder');
  },
  data() {
    return {
      showModal: false,
      slider: groups,
    };
  },
};
</script>

<style scoped lang="scss">
// @TODO: Create own component
.slider {
  .VueCarousel-inner {
    padding-right: 200px;
  }

  .VueCarousel-inner > div:nth-child(3) {}

  .VueCarousel-dot-container button {}
}

.teaser {
  background-color: $color-contrast-light;
  height: 100%;
  margin: 0 15px;
  display: block;
  position: relative;
  color: $color-black;
  text-align: left;
  text-decoration: none;

  &::after {
    display: block;
    content: '►';
    position: absolute;
    right: 25px;
    bottom: 30px;
    color: $color-primary;
  }

  &__image {
    background: no-repeat center;
    background-size: cover;
    padding-bottom: 56.25%; // 16:9 aspect ratio
  }

  &__text {
    padding: 25px;
  }
}
</style>
